import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/port0.jpg";
import IMG2 from "../../assets/port1.jpg";
import IMG3 from "../../assets/port4.jpg";
import IMG4 from "../../assets/port6.jpg";
import IMG5 from "../../assets/port8.jpg";
import IMG6 from "../../assets/port9.jpg";
import Slideshow from "./Slideshow";
import slide1 from "../../assets/Screenshot 2025-05-13 at 7.59.55 PM.png";
import slide2 from "../../assets/Screenshot 2025-05-13 at 8.00.14 PM.png";

import slide4 from "../../assets/Screenshot 2025-05-13 at 8.11.11 PM.png";
import slide5 from "../../assets/Screenshot 2025-05-13 at 8.11.33 PM.png";
import slide6 from "../../assets/Screenshot 2025-05-13 at 8.12.02 PM.png";

import slide7 from "../../assets/Screenshot 2025-05-13 at 9.16.31 PM.png";
import slide8 from "../../assets/Screenshot 2025-05-13 at 9.16.40 PM.png";
import slide9 from "../../assets/Screenshot 2025-05-13 at 9.16.51 PM.png";

import "./slideshow.css";

// DO NOT USE THE IMAGES IN PRODUCTION

const data = [
  {
    id: 1,
    image: IMG1,
    title:
      "Built a full-featured iOS app (FirePit) using Swift and Google Firebase, with real-time database integration, geo-location tracking to identify users in proximity, and a custom sorting algorithm to intelligently match users in the area. Included robust messaging features and seamless user experience.",
    github: "https://github.com/ahawk32/UGA-Hackathon",
    demo: "https://youtu.be/8ulZ5gVmTMI",
  },
  {
    id: 2,
    image: IMG2,
    title: "Built an online career development service (zero-to-offer.com)",
    github: "#", // Update with actual repo if available
    demo: "https://zero-to-offer.com/",
    description: "Developed a full-stack online career development platform that has helped many people achieve their dream jobs and escape unemployment. Built both frontend and backend functionality, leveraging Supabase as a backend service for secure data collection and management.",
    slides: [slide7, slide8, slide9],

  },
  {
    id: 3,
    image: IMG4,
    title:
      "Developed an advanced iOS application that deploys an InceptionV3 ML model for real-time image recognition of food items, and leverages the OpenAI API to estimate both the resale value and caloric content of detected foods, providing users with actionable insights.",
    github: "https://github.com/ahawk32/SeeFood",
    demo: true,
  },
  {
    id: 4,
    image: IMG3,
    title: "Developed Pong game with Python and pygame libraries",
    github: "https://github.com/ahawk32/Abrar-Pong-Game.git",
    demo: null,
  },
  {
    id: 5,
    image: IMG5,
    title: "OptiMed Health Insurance Portal",
    description: `I built an enterprise-grade insurance portal for OptiMed Health that manages over 100 accounts and processes millions of dollars in transactions annually. The portal streamlines claims, policy management, and reporting for both clients and internal teams, ensuring security and scalability.`,
    github: null,
    demo: "https://www.optimedhealthportal.com/",
    slides: [slide1, slide2, slide4, slide5, slide6],
  },
  {
    id: 6,
    image: IMG6,
    title: "Python Web Scrapper Utilizing Twitter and Yahoo APIs to determine sentiment of given stock",
    github: null,
    demo: true,
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2 style={{ fontSize: "2.0rem" }}>Portfolio</h2>

      <div className="container portfolio__container">
        {/* Render the primary tile first */}
        {(() => {
          const primary = data.find((item) => item.id === 5);
          const others = data.filter((item) => item.id !== 5);
          return [
            <article key={primary.id} className="portfolio__item portfolio__item--primary">
              <div className="portfolio__item-image">
                {primary.slides ? (
                  <Slideshow images={primary.slides} />
                ) : (
                  <img src={primary.image} alt={primary.title} />
                )}
              </div>
              <h3 className="portfolio__item-title--primary">{primary.title}</h3>
              {primary.description && (
                <p
                  style={{
                    margin: "0.5rem 0 1rem 0",
                    fontWeight: 500,
                    color: "#222",
                    fontSize: "1.1rem",
                    lineHeight: 1.5,
                  }}
                >
                  {primary.description}
                </p>
              )}
              <div className="portfolio__item-cta">
                {primary.github === null ? null : (
                  <a href={primary.github} className="btn" target="_blank" rel="noreferrer">
                    Github
                  </a>
                )}
                {primary.demo === null ? null : (
                  <a
                    href={primary.demo === true ? "#contact" : primary.demo}
                    className="btn btn-primary"
                    target={primary.demo === true ? "_self" : "_blank"}
                    rel={primary.demo === true ? undefined : "noreferrer"}
                  >
                    {primary.demo === true ? "Request Demo" : "Live Demo"}
                  </a>
                )}
              </div>
            </article>,
            ...others.map(({ id, image, title, github, demo, slides, description }) => (
              <article key={id} className="portfolio__item">
                <div className="portfolio__item-image">
                  {slides ? <Slideshow images={slides} /> : <img src={image} alt={title} />}
                </div>
                <h3>{title}</h3>
                {description && (
                  <p style={{ margin: "0.5rem 0 1rem 0", fontWeight: 500, color: "#333" }}>{description}</p>
                )}
                <div className="portfolio__item-cta">
                  {github === null ? null : (
                    <a href={github} className="btn" target="_blank" rel="noreferrer">
                      Github
                    </a>
                  )}
                  {demo === null ? null : (
                    <a
                      href={demo === true ? "#contact" : demo}
                      className="btn btn-primary"
                      target={demo === true ? "_self" : "_blank"}
                      rel={demo === true ? undefined : "noreferrer"}
                    >
                      {demo === true ? "Request Demo" : "Live Demo"}
                    </a>
                  )}
                </div>
              </article>
            )),
          ];
        })()}
      </div>
    </section>
  );
};

{
  /*const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {
          data.map(({id, image, title, github, demo}) => {
            return (
              <article key={id} className='portfolio__item'>
                <div className="portfolio__item-image">
                  <img src={image} alt={title} />
                </div>
                <h3>{title}</h3>
                <div className="portfolio__item-cta">
                  <a href={github} className='btn' target='_blank'>Github</a>
                  <a href={demo ? demo : '#'} className='btn btn-primary' target='_blank'>{demo ? 'Live Demo' : 'Request Demo'}</a>
                </div>
              </article>
            )
          })
        }
      </div>
    </section>
  )
}*/
}

export default Portfolio;
